import { createClient, SupabaseClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || "";
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  // eslint-disable-next-line no-console
  console.warn(
    "[supabase] Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY env vars. Supabase calls will fail."
  );
}

/**
 * Singleton Supabase client. Uses the publishable (anon) key only.
 * The service role key NEVER touches the frontend.
 */
let _client: SupabaseClient | null = null;
export const supabase = (): SupabaseClient => {
  if (_client) return _client;
  _client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: { persistSession: true, autoRefreshToken: true },
  });
  return _client;
};

export default supabase;
